module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Barang")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/barang_accurate"
    }
  }, [_vm._v("Accurate")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [_c('h4', [_c('b', [_vm._v("DATA ACCURATE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": "",
      "hover": "",
      "max-height": "505",
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "header-align": "center",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.row.no) + ".\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "SKU",
      "prop": "ITEMNO",
      "header-align": "left",
      "align": "left",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter SKU"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariSku()
            }
          },
          model: {
            value: (_vm.cari_sku),
            callback: function($$v) {
              _vm.cari_sku = $$v
            },
            expression: "cari_sku"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.ITEMNO))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "BARANG",
      "prop": "ITEMDESCRIPTION",
      "header-align": "left",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Barang"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariNama()
            }
          },
          model: {
            value: (_vm.cari_nama),
            callback: function($$v) {
              _vm.cari_nama = $$v
            },
            expression: "cari_nama"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.ITEMDESCRIPTION))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "STOK",
      "prop": "QUANTITY",
      "header-align": "left",
      "align": "left",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(_vm.toMoney(parseFloat(scope.row.QUANTITY))) + "\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "SATUAN",
      "prop": "UNIT1",
      "header-align": "left",
      "align": "left",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.row.UNIT1) + "\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "WAREHOUSE",
      "prop": "WH",
      "header-align": "left",
      "align": "left",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.row.WH) + "\n                          ")] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.tableData.length,
      "page-size": _vm.page_size,
      "current-page": _vm.current_page
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55b41f34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/BarangAccurate.vue
// module id = 1389
// module chunks = 2